import Dashboard from "./dashboard/Dashboard";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { Route, Routes, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ConfirmPopup from './common/ConfirmPopup';
import ProgramForm from "./program/ProgramForm";
import CourseForm from "./course/CourseForm";
import LessonForm from "./lesson/LessonForm";
import System from "./system/System";
import AppConfig from "./app_config/AppConfig";
import Curriculum from "./curriculum/Curriculum";
import ProgramCourses from "./curriculum/ProgramCourses";
import CourseLessons from "./curriculum/CourseLessons";
import LessonDetails from "./curriculum/LessonDetails";
import { SidebarProvider, SidebarInset } from "./ui/sidebar";

const AdminPortal = () => {
    const navigate = useNavigate();

    useSelector(state => {
        let accessToken = state.auth.accessToken;
        if (accessToken == null) {
            navigate('/login');
            return;
        }
    });

    return (
        <SidebarProvider>
            <Sidebar />
            <SidebarInset>
                <Navbar />
                <div className="flex flex-1 flex-col bg-background text-foreground">
                    <div className="flex flex-1 flex-col gap-2">
                        <div className="flex flex-col gap-4 py-4 md:gap-6 md:py-6">
                            <main className="px-4 lg:px-6">
                                <Routes>
                                    <Route path="app_config" element={<AppConfig />} />
                                    <Route path="curriculum/programs/new" element={<ProgramForm />} />
                                    <Route path="curriculum/programs/:programId" element={<ProgramForm />} />
                                    <Route path="curriculum/programs/:programId/courses" element={<ProgramCourses />} />
                                    <Route path="curriculum/courses/new" element={<CourseForm />} />
                                    <Route path="curriculum/courses/:courseId" element={<CourseForm />} />
                                    <Route path="curriculum/programs/:programId/courses/new" element={<CourseForm />} />
                                    <Route path="curriculum/courses/:courseId/lessons" element={<CourseLessons />} />
                                    <Route path="curriculum/lessons/new" element={<LessonForm />} />
                                    <Route path="curriculum/lessons/:lessonId" element={<LessonForm />} />
                                    <Route path="curriculum/courses/:courseId/lessons/new" element={<LessonForm />} />
                                    <Route path="curriculum/lessons/:lessonId/details" element={<LessonDetails />} />
                                    <Route path="curriculum" element={<Curriculum />} />
                                    <Route path="system" element={<System />} />
                                    <Route path="" element={<Dashboard />} />
                                </Routes>
                            </main>
                        </div>
                    </div>
                </div>
                <ConfirmPopup />
            </SidebarInset>
        </SidebarProvider>
    );
};

export default AdminPortal;

